/* eslint-disable */
import missingService from "../services/missing-service";
export default {
  state: {
    missings: [],
    userMissings: [],
    missing: {},
    pageNumber: 1,
    pageSize: 0,
    totalCount: 0
  },
  mutations: {
    updateMissings(state, { missings, pageNumber, pageSize, totalCount }) {
      state.missings = missings;
      (state.pageNumber = pageNumber), (state.pageSize = pageSize), (state.totalCount = totalCount);
    },
    updateUserMissings(state, { missings, pageNumber, pageSize, totalCount }) {
      state.userMissings = missings;
      (state.pageNumber = pageNumber), (state.pageSize = pageSize), (state.totalCount = totalCount);
    },

    updateMissing(state, missing) {
      state.missing = missing;
    },
    deleteMissing(state, id) {
      state.userMissings = state.userMissings.filter(m => m.id !== id);
    }
  },
  actions: {
    async getMissings(context, pageNumber = 1) {
      let { selectedCategory, selectedCity } = context.rootState.SearchStore;
      context.dispatch("toggleLoading");
      var response = await missingService.getMissings(pageNumber, selectedCity, selectedCategory);
      context.commit("updateMissings", response.data);
      context.dispatch("toggleLoading");
    },
    async getUserMissings(context, pageNumber = 1) {
      context.dispatch("toggleLoading");
      var response = await missingService.getUserMissings(pageNumber);
      console.log(response);

      context.commit("updateUserMissings", response.data);
      context.dispatch("toggleLoading");
    },
    async getMissing(context, id) {
      context.dispatch("toggleLoading");
      var response = await missingService.getMissing(id);
      context.commit("updateMissing", response.data);
      context.dispatch("toggleLoading");
    },

    async deleteMissing(context, id) {
      context.dispatch("toggleLoading");
      var response = await missingService.deleteMissing(id);
      context.commit("deleteMissing", id);
      context.dispatch("toggleLoading");
    }
  }
};
